import { NgModule } from '@angular/core';
import { FiEditorPageComponent } from './fi-editor-page.component';
import { FiEditorPageTranscludeComponent } from './fi-editor-page-transclude.component';
import {
    FiEditorPageContentCenterDirective,
    FiEditorPageContentCenterRootDirective,
} from './fi-editor-page-content-center.directive';
import { FiContenteditableSimpleTextPanelHandlerModule } from '../fi-contenteditable-simple-text-panel-handler/fi-contenteditable-simple-text-panel-handler.module';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule, FiContenteditableSimpleTextPanelHandlerModule],
    declarations: [
        FiEditorPageComponent,
        FiEditorPageTranscludeComponent,
        FiEditorPageContentCenterDirective,
        FiEditorPageContentCenterRootDirective,
    ],
    exports: [
        FiEditorPageComponent,
        FiEditorPageTranscludeComponent,
        FiEditorPageContentCenterDirective,
        FiEditorPageContentCenterRootDirective,
    ],
})
export class FiEditorPageModule {}
